(function () {
  function initSlideshow(el) {
    var slides = Array.from(el.querySelectorAll('.about-feature__slide'));
    if (slides.length < 2) return;
    var current = 0;

    var timer = setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 4000);

    return timer;
  }

  function init() {
    document.querySelectorAll('.js-about-feature-slideshow').forEach(function (el) {
      initSlideshow(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.js-about-feature-slideshow');
    if (el) initSlideshow(el);
  });
})();
